import {
  TRecord,
  TListOfElement,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';
import {withSystem, Plugins} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

export type OgImageValue = {id: string} | {url: string};

export type CurrentPage = {
  name: string;
  seoTitle?: string;
  seoDesc?: string;
  ogTitle?: string;
  ogDesc?: string;
  parentFolderName?: string;
  ogImage?: OgImageValue;
};

const TImage = TTypeConstructor(
  qualify(Plugins.name('Asset'), typeName('Image'))
);

export const TCurrentPage = withSystem(
  {label: 'Current page'},
  TRecord({
    name: withSystem({label: 'Name'}, TListOfElement),
    parentFolderName: withSystem({label: 'Folder name'}, TListOfElement),
    seoTitle: withSystem({label: 'Title tag'}, TListOfElement),
    seoDesc: withSystem({label: 'Meta description'}, TListOfElement),
    ogTitle: withSystem({label: 'Open Graph title'}, TListOfElement),
    ogDesc: withSystem({label: 'Open Graph description'}, TListOfElement),
    ogImage: withSystem({label: 'Open Graph image'}, TImage),
  })
);
